export default "__VITE_ASSET__d3a20819__"